exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.i(require("-!../../../node_modules/css-loader/index.js?modules=true&localIdentName=[name]__[local]___[hash:base64:5]!../../colours.icss"), undefined);

// module
exports.push([module.id, ".Colour__section___3rFcT {\n\tflex: 1;\n}\n\n.Colour__selectBox___3q_Qp {\n    width: 100%;\n}\n\n.Colour__colourSelect___5MDmg {\n    margin: 0.7rem 0.7rem 0.5rem " + require("-!../../../node_modules/css-loader/index.js?modules=true&localIdentName=[name]__[local]___[hash:base64:5]!../../colours.icss").locals["pagePadding"] + "; \n}\n\n.Colour__noMultipleColours___uPMFK {\n    border-bottom: 1px solid rgba(0, 0, 0, 0.42);\n    padding: " + require("-!../../../node_modules/css-loader/index.js?modules=true&localIdentName=[name]__[local]___[hash:base64:5]!../../colours.icss").locals["pagePadding"] + ";\n}\n", ""]);

// exports
exports.locals = {
	"pagePadding": "" + require("-!../../../node_modules/css-loader/index.js?modules=true&localIdentName=[name]__[local]___[hash:base64:5]!../../colours.icss").locals["pagePadding"] + "",
	"section": "Colour__section___3rFcT",
	"selectBox": "Colour__selectBox___3q_Qp",
	"colourSelect": "Colour__colourSelect___5MDmg",
	"noMultipleColours": "Colour__noMultipleColours___uPMFK"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?modules=true&localIdentName=[name]__[local]___[hash:base64:5]!./src/components/Item/Colour.icss
// module id = 1297
// module chunks = 0